<template>
    <div class="upload">
        <div class="upload_item">
            <p>一般纳税人资质 <span>(png、jpg或pdf)</span></p>
            <el-upload class="upload-demo" :class="{ 'uploadActive': percentage == 100 }" ref="upload" drag action="#"
                :show-file-list="false" :before-upload="beforeAvatarUpload" :http-request="requestDeposit_info"
                :file-list="fileList">
                <div class="el-upload__text">
                    <div>
                        <i class="el-icon-document" v-if="percentage > 0" :style="{ 'font-size': '16px' }"></i>
                        <p>{{ uploadName }}</p>
                    </div>
                    <span v-if="percentage < 100 && percentage > 0">{{ percentage }}%</span>
                    <div class="success">
                        <i v-if="percentage == 100" class="el-icon-delete" @click.stop="removePic"></i>
                        <img src="@/assets/home/upload (2).png" alt="">
                    </div>
                </div>
                <el-progress  v-if="percentage >0 && percentage<100" :percentage="percentage" status="exception" :stroke-width="2"
                    :show-text="false">
                </el-progress>
            </el-upload>

        </div>
        <div class="upload_item">
            <p>开户许可证或基本存缴信息证明 <span>(png、jpg或pdf)</span></p>
            <el-upload class="upload-demo" ref="upload" drag action="#" :show-file-list="false"
                :before-upload="beforeAvatarUpload" :http-request="requestDeposit_info1">
                <div class="el-upload__text">
                    <div>
                        <i class="el-icon-document" v-if="percentage1 > 0" :style="{ 'font-size': '16px' }"></i>
                        <p>{{ uploadName1 }}</p>
                    </div>
                    <span v-if="percentage1 < 100 && percentage1 > 0">{{ percentage1 }}%</span>
                    <div class="success">
                        <i v-if="percentage1 ==100" class="el-icon-delete" @click.stop="removePic(1)"></i>
                        <img src="@/assets/home/upload (2).png" alt="">
                    </div>
                </div>
                <el-progress v-if="percentage1 >0 && percentage1<100" :percentage="percentage1" status="exception" :stroke-width="2"
                    :show-text="false">
                </el-progress>
            </el-upload>
        </div>
    </div>
</template>
<script>
export default {
    data() {
        return {
            fileList: [],
            fileList1: [],
            percentage: 0,
            uploadName: '点击或拖拽上传文件',
            percentage1: 0,
            uploadName1: '点击或拖拽上传文件',
        }
    },
    methods: {
        beforeAvatarUpload(file) {
            const isLt2M = file.size / 1024 / 1024 < 2;
            if (!isLt2M) {
                this.$msg('error', '提示', '上传图片大小不能超过 2MB!');
            }
            let flag = file.type === 'image/jpeg' || file.type === 'application/pdf' || file.type === 'image/png'
            if (!flag) {
                this.$msg('error', '提示', '只能上传png、jpg或pdf 格式文件!');
            }
            this.$refs.upload.clearFiles();
            return flag && isLt2M;
        },
        // 上传基本存款信息证明 (pdf / jpg / png)
        requestDeposit_info(val) {
            if (this.fileList.length >= 1) return this.$msg('error', '提示', '只能上传一张证明')
            this.uploadName = val.file.name
            let timer = setInterval(() => {
                this.percentage+=5
                if (this.percentage == 95) {
                    clearInterval(timer)
                    timer = null
                }
            }, 20)
            this.fileList.push(val.file)
            let formData = new FormData()
            formData.append('up_file', val.file)
            formData.append('folder', 'license')
            this.$home.upload(formData).then(res => {
                if (res.code == 200) {
                    clearInterval(timer)
                    timer = null
                    this.percentage = 100
                    this.$emit('taxpayer',res.data.url)
                } else {
                    clearInterval(timer)
                    timer = null
                }
            }).catch(err => {
                clearInterval(timer)
                timer = null
            })
        },
        // 上传基本存款信息证明 (pdf / jpg / png)
        requestDeposit_info1(val) {
            if (this.fileList1.length >= 1) return this.$msg('error', '提示', '只能上传一张证明')
            this.uploadName1 = val.file.name
            let timer = setInterval(() => {
                this.percentage1++
                if (this.percentage1 == 99) {
                    clearInterval(timer)
                    timer = null
                }
            }, 10)
            this.fileList1.push(val.file)
            let formData = new FormData()
            formData.append('up_file', val.file)
            formData.append('folder', 'license')
            this.$home.upload(formData).then(res => {
                if (res.code == 200) {
                    clearInterval(timer)
                    timer = null
                    this.percentage1 = 100
                    this.$emit('deposit',res.data.url)
                } else {
                    clearInterval(timer)
                    timer = null
                }
            }).catch(err => {
                clearInterval(timer)
                timer = null
            })
        },
        removePic(idx) {
            if (idx == 1) {
                this.uploadName1 = '点击或拖拽上传文件'
                this.percentage1 = 0
                this.fileList1 = []
            } else {
                this.uploadName = '点击或拖拽上传文件'
                this.percentage = 0
                this.fileList = []
            }
        }
    }
}
</script>
<style lang="scss" scoped>
::v-deep .el-upload-dragger {
    width: 300px;
    height: 38px;
    margin-top: 10px;
    border: none;
    border-radius: 0px;
}

::v-deep .el-upload-dragger:hover {
    border: none;
}

.uploadActive {
    z-index: -1;
}

::v-deep .el-upload__text {
    width: 300px;
    height: 36px;
    background: #F8F8F8;
    border: 1px dashed #DEDEDE;
    display: flex;
    padding-left: 8px;
    font-size: 12px;
    align-items: center;
    justify-content: space-between;
    padding: 0 8px;

    >div {
        display: flex;
        align-items: center;
        gap: 8px;
    }

    .success {
        font-size: 16px;
    }
}

.upload {
    display: flex;
    margin-top: 24px;
    border-bottom: 1px dashed #AAAAAA;
    padding-bottom: 30px;
    gap: 30px;

    span {
        font-size: 12px;
        color: #999999;
    }
}

</style>